import cn from 'classnames'
import { useCallback } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Checkbox } from 'core-components/library/checkbox'

import { useFormField } from '../../hooks'
import { ReadOnlyField } from '../readOnlyField'

import { IFormCheckBoxProps } from './models'

import styles from './FormCheckBox.module.scss'

export const FormCheckBox = <T = boolean | number,>({
  field,
  formKey,
  label = '',
  defaultValue,
  className,
  onChange,
  isVisible = true,
  isDisabled,
  isReadOnly,
  isRequired,
}: IFormCheckBoxProps<T>) => {
  const { handleChange, value } = useFormField<T>({
    field,
    formKey,
    defaultValue,
    onChange,
    isDisabled,
    isRequired,
    isReadOnly,
  })

  const onChangeHandler = useCallback(
    (newValue: boolean) => {
      if (typeof value === 'number') {
        handleChange((newValue ? 1 : 0) as T)
      } else {
        handleChange(newValue as T)
      }
    },
    [handleChange, value]
  )

  if (isVisible === false) {
    return null
  }

  if (isReadOnly) {
    return <ReadOnlyField label={label} value={value} />
  }

  return (
    <Checkbox
      disabled={isDisabled}
      className={cn(className, styles.checkbox)}
      label={label && <Translation text={label} span />}
      checked={Boolean(value)}
      onChange={onChangeHandler}
    />
  )
}
